import { THEME } from '@Theme';
import { StyleSheet } from 'aphrodite';

/**
 * Styling for an Account Overview note: the title + add-action header, the author/date
 * meta line, the read-only rich content, and the legacy "Missing!" warning treatment.
 * All tokens come from `THEME`.
 */
export const accountNoteStyles = StyleSheet.create({
	container: {
		border: THEME.common.border,
		borderRadius: THEME.common.borderRadius,
		boxSizing: 'border-box',
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.xs,
		height: '100%',
		padding: THEME.spacing.md,
	},
	header: {
		alignItems: 'center',
		display: 'flex',
		gap: THEME.spacing.sm,
		justifyContent: 'space-between',
	},
	title: {
		color: THEME.colors.text.main,
		fontSize: THEME.typography.fontSizes.sm,
		fontWeight: THEME.typography.fontWeights.bold,
	},
	actions: {
		alignItems: 'center',
		display: 'flex',
		gap: THEME.spacing.md,
	},
	actionButton: {
		alignItems: 'center',
		background: 'none',
		border: 'none',
		color: THEME.colors.primary.main,
		cursor: 'pointer',
		display: 'inline-flex',
		fontSize: THEME.typography.fontSizes.sm,
		gap: THEME.spacing.xs,
		// Override the components-v2 Button's fixed size so the link-style button sits inline.
		height: 'auto',
		padding: 0,
		whiteSpace: 'nowrap',
		':hover': {
			color: THEME.colors.hover.main,
		},
	},
	meta: {
		color: THEME.colors.text.light,
		display: 'flex',
		flexWrap: 'wrap',
		fontSize: THEME.typography.fontSizes.xs,
		gap: THEME.spacing.sm,
	},
	content: {
		color: THEME.colors.text.main,
		fontSize: THEME.typography.fontSizes.sm,
	},
	expandToggle: {
		alignSelf: 'flex-start',
		fontSize: THEME.typography.fontSizes.xs,
	},
	emptyState: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.sm,
	},
	errorState: {
		color: THEME.colors.danger.main,
		fontSize: THEME.typography.fontSizes.sm,
	},
});
